import React from 'react';
import { Moon } from 'lucide-react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
export function Hero() {
  return <section className="relative pt-24 pb-20 md:pt-32 md:pb-28 px-4 overflow-hidden" data-id="element-75">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-76">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-brand-lavenderLight/50 blur-3xl" data-id="element-77" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] rounded-full bg-brand-sageLight/50 blur-3xl" data-id="element-78" />
      </div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-79">
        <FadeIn delay={0.1} data-id="element-80">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white shadow-sm border border-brand-lavenderLight mb-8" data-id="element-81">
            <Moon className="w-4 h-4 text-brand-lavender" data-id="element-82" />
            <span className="text-sm font-medium text-brand-lavender tracking-wide uppercase" data-id="element-83">
              Las 7 Claves para la Menopausia 40+
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-84">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-dark leading-tight mb-6" data-id="element-85">
            El Protocolo de las 16 Horas: <br className="hidden md:block" data-id="element-86" />
            <span className="text-brand-lavender italic font-normal" data-id="element-87">
              Recupera tu Cuerpo y tu Sueño tras los 40
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-88">
          <p className="text-xl md:text-2xl text-brand-dark/80 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-89">
            El ritual nocturno diseñado para silenciar sofocos, desinflamar el
            abdomen y reactivar tu energía mientras duermes.
          </p>
        </FadeIn>

        <FadeIn delay={0.35} data-id="element-90">
          <div className="relative max-w-4xl mx-auto mb-12 rounded-2xl overflow-hidden shadow-2xl border border-brand-lavenderLight/50" data-id="element-91">
            <img src="https://cdn.magicpatterns.com/uploads/31ZN3EqK8qtd9NkZ3cTPS5/heylloyd-image-1774410061915.png" alt="Las 7 Claves para la Menopausia 40+ en dispositivos" className="w-full h-auto object-cover" data-id="element-92" />
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-93">
          <div className="bg-white/80 backdrop-blur-sm p-6 md:p-8 rounded-2xl shadow-sm border border-brand-lavenderLight/50 max-w-2xl mx-auto mb-10 text-left relative" data-id="element-94">
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-brand-lavender rounded-l-2xl" data-id="element-95" />
            <p className="text-lg text-brand-dark/90 italic leading-relaxed" data-id="element-96">
              "Son las 3 de la mañana. Te despiertas empapada en sudor, con el
              corazón acelerado y una frustración que no te deja volver a cerrar
              los ojos. Miras el reloj y sabes que mañana será otro día de
              neblina mental, cansancio extremo y esa sensación de que tu cuerpo
              ya no te pertenece."
            </p>
            <p className="mt-4 text-brand-dark font-medium" data-id="element-97">
              No es falta de voluntad. No es solo "hacerse mayor". Es un
              desajuste hormonal que la medicina tradicional ignora, pero que
              puedes empezar a revertir esta misma noche.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}